import { Box } from '@mui/material'
import {
  closeMidasPanel,
  useMidasEnabled,
  useMidasPanelOpen
} from 'hooks/useMidas'
import MidasLauncher, { resetLauncherAnimation } from './MidasLauncher'
import MidasPanel from './MidasPanel'
import { LAUNCHER_CLEARANCE } from './useLauncherBottom'

// Midas launcher + chat panel. Renders nothing unless the `midas_enabled` flag
// and the Midas config both say enabled.
export default function Midas() {
  const { enabled, config } = useMidasEnabled()
  const open = useMidasPanelOpen()

  if (!enabled || !config) return null

  return (
    <>
      <MidasLauncher hidden={open} />
      <MidasPanel open={open} onClose={closeMidasPanel} config={config} />
    </>
  )
}

// Blank space at the end of a page, while the launcher shows, so the page's last
// control can scroll clear of it. BaseLayout leaves it out when the page has its
// own pinned footer: the launcher already rises above that.
export function MidasLauncherClearance() {
  const { enabled } = useMidasEnabled()
  if (!enabled) return null
  return (
    <Box
      aria-hidden
      data-testid='midas-launcher-clearance'
      sx={{ height: LAUNCHER_CLEARANCE, flexShrink: 0 }}
    />
  )
}

// Test hook: lets each test see the first-appearance animation afresh.
export function resetMidasLauncherForTests(): void {
  resetLauncherAnimation()
  closeMidasPanel()
}
